import { ThemeProvider } from 'styled-components'
import { designSystemTheme } from '@velasca/constants'
import { isWoman } from '@velasca/utils/globals'

const theme = designSystemTheme[isWoman ? 'woman' : 'man']

export const withTheme = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <ThemeProvider theme={theme}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    )
  }
}
